<template>
  <div v-if="offerSummary.length > 0" class="summary">
    <table class="offers-table full-width">
      <tr v-for="offer in offerSummary" :key="offer.lender" class="offer">
        <td class="full-width pr-4">
          <div
            v-if="offer.lender === 'other'"
            class="otherOffer d-flex align-items-center"
          >
            <span class="icon fa-regular fa-money-bill-1-wave mr-3"></span>
            <span data-cy="otherOfferText">
              {{ otherLenderOfferText }}
            </span>
          </div>
          <div v-else class="lenderOffer d-flex align-items-center">
            <div class="logoContainer mr-3">
              <img
                v-if="lenders[offer.lender]?.logo"
                :src="lenders[offer.lender].logo"
              />
            </div>
            <span data-cy="lenderOfferText">
              Flexible Financing Options Available
            </span>
          </div>
        </td>
        <td class="text-right pr-2">
          <span>Payments as low as</span>
        </td>
        <td class="paymentsAsLowAsValue text-right">
          <span data-cy="paymentsAsLowAsValue">{{
            dollars(offer.paymentsAsLowAsCents)
          }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";

import { useFinancingAvailable } from "./useFinancingAvailable";

const { lenders, offerSummary } = useFinancingAvailable();

const otherLenderOfferText = computed(() => {
  if (offerSummary.value.length > 1) {
    return "Other Financing Plans Available";
  } else {
    return "Financing Plans Available";
  }
});
</script>

<style lang="scss" scoped>
.summary {
  margin-top: 0.5rem;
  border: 0px;
  background: none;
  border-radius: 0px;
  padding: 0px;

  .offers-table {
    background: linear-gradient(274deg, #d6f8d8 0%, #f6f7f7 41.67%);
  }
  .offer {
    border-top: 1px solid #c9cdd0;
    * {
      white-space: nowrap;
    }
    td {
      padding: 14px 0;
      &:first-child {
        padding-left: 24px;
      }
      &:last-child {
        padding-right: 24px;
      }
    }
  }
  .lenderOffer {
    .logoContainer {
      width: 120px;
    }
    img {
      max-width: 120px;
    }
  }
  .otherOffer {
    .icon {
      font-size: 32px;
      color: #9ca4aa;
    }
  }
  .paymentsAsLowAsValue {
    font-size: 24px;
    font-weight: 600;
  }
  @media (max-width: 1100px) {
    font-size: 12px;
    .paymentsAsLowAsValue {
      font-size: 16px;
      font-weight: 600;
    }
  }
}
</style>
